import bg from './bg';
import en from './en';
import ru from './ru';

export const resources = { bg, en, ru };
